import { render, staticRenderFns } from "./Review_review.vue?vue&type=template&id=96eef10a&style=height%3A100%25"
import script from "./Review_review.vue?vue&type=script&lang=js"
export * from "./Review_review.vue?vue&type=script&lang=js"
import style0 from "./Review_review.vue?vue&type=style&index=0&id=96eef10a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports